export enum MentionTriggerType {
  Emoji = ':',
  Field = '#',
  User = '@',
}
